//BD: Pergunta
export const enum EGuidTipoSasFrequenciaMedicao {
  'Mensal' = '4F889B7E-5C1A-46BC-BDE1-244271B02543',
}
